import type { CoreApiClient } from "../client";
import { createHistoryQueries } from "../queries/history.queries";

export const createHistoryRepository = (api: CoreApiClient) => ({
  ...createHistoryQueries(api),
});
